// Запросы бэкапов: /api/backups.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api } from '@/api/client'

export type BackupRun = {
  id: string
  started_at: string
  finished_at: string | null
  filename: string | null
  size_bytes: number | null
  local_ok: boolean
  s3_ok: boolean | null
  error: string | null
  ok: boolean
}

export type BackupStatus = {
  last_success: BackupRun | null
  last_run: BackupRun | null
  s3_configured: boolean
  local_count: number
  keep_local: number
  keep_s3: number
  runs: BackupRun[]
}

export const backupKeys = { status: ['backups'] as const }

export const backupApi = {
  status: () => api.get<BackupStatus>('/backups'),
  run: () => api.post<BackupRun>('/backups/run', {}),
}

export function useBackupStatus() {
  return useQuery({ queryKey: backupKeys.status, queryFn: backupApi.status })
}

export function useRunBackup() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: backupApi.run,
    onSettled: () => client.invalidateQueries({ queryKey: backupKeys.status }),
  })
}
